import type { EventPopup } from '../services/api/popupApi';

// 「오늘 하루 보지 않기」 — 팝업마다 한국 날짜로 기억한다. 키 접두어는 preservedStorage.ts 가 캐시 초기화에서 지키는
// 목록에 들어 있다(안 그러면 1시간 미사용·새 배포 때 지워져 같은 날 팝업이 다시 뜬다).
const PREFIX = 'awana-popup-hide-';

export const hideKey = (id: string) => `${PREFIX}${id}`;

export const kstDate = (now: Date = new Date()) => new Date(now.getTime() + 9 * 3600 * 1000).toISOString().slice(0, 10);

export const isHiddenToday = (id: string, now: Date = new Date()): boolean => {
  try {
    return localStorage.getItem(hideKey(id)) === kstDate(now);
  } catch (e) {
    return false;
  }
};

export const hidePopupToday = (id: string, now: Date = new Date()) => {
  try {
    localStorage.setItem(hideKey(id), kstDate(now));
  } catch (e) {
    // 저장이 막힌 브라우저(사생활 보호 모드 등)에서는 이번에만 닫힌다
  }
};

export const popupsToShow = (popups: EventPopup[], now: Date = new Date()) =>
  popups.filter((p) => !isHiddenToday(p.id, now));
